var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToggleMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 10.1875H3.75C3.2375 10.1875 2.8125 9.7625 2.8125 9.25C2.8125 8.7375 3.2375 8.3125 3.75 8.3125H26.25C26.7625 8.3125 27.1875 8.7375 27.1875 9.25C27.1875 9.7625 26.7625 10.1875 26.25 10.1875Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 16.4375H3.75C3.2375 16.4375 2.8125 16.0125 2.8125 15.5C2.8125 14.9875 3.2375 14.5625 3.75 14.5625H26.25C26.7625 14.5625 27.1875 14.9875 27.1875 15.5C27.1875 16.0125 26.7625 16.4375 26.25 16.4375Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 22.6875H3.75C3.2375 22.6875 2.8125 22.2625 2.8125 21.75C2.8125 21.2375 3.2375 20.8125 3.75 20.8125H26.25C26.7625 20.8125 27.1875 21.2375 27.1875 21.75C27.1875 22.2625 26.7625 22.6875 26.25 22.6875Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleMenu);
export default __webpack_public_path__ + "static/media/toggle-menu.cccdd751311a981e9c90ea86c535b623.svg";
export { ForwardRef as ReactComponent };